import React from 'react'
import "./About_vission_mission.css"

function About_vission_mission() {
    return (
        <>
            <section className='About_vission_mission'>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-xl-3 col-md-4 col-sm-6 mb-5">
                            <div className='About_vission_mission_card'>
                                <div className='inner_card_holder'>
                                    <div className='img_holder'>
                                        <img className="logo_img"
                                            src={
                                                process.env.PUBLIC_URL +
                                                "/assets/images/about_us/about_vission_mission/mission.png"
                                            }
                                            alt=" logo" />
                                    </div>

                                    <div className='text_holder'>
                                        <h4>Our Mission</h4>
                                        <div className='list_holder'>
                                            <p>To provide essential value to your supply chain in order to advance and overcome the obstacles of doing international trade.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-xl-3 col-md-4 col-sm-6 mb-5">
                            <div className='About_vission_mission_card'>
                                <div className='inner_card_holder'>
                                    <div className='img_holder'>
                                        <img className="logo_img"
                                            src={
                                                process.env.PUBLIC_URL +
                                                "/assets/images/about_us/about_vission_mission/advantage.png"
                                            }
                                            alt="ayansh logo" />
                                    </div>

                                    <div className='text_holder'>
                                        <h4>Our Commitment</h4>

                                        <div className='list_holder'>
                                            <ul>
                                                <li>Advanced chain solutions</li>

                                                <li>Ethical sourcing</li>

                                                <li>Advanced chain solutions</li>

                                                <li>Add value to customers.</li>

                                                <li>Tailored financial solutions</li>

                                                <li>Efficient delivery.</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-xl-3 col-md-4 col-sm-6 mb-5">
                            <div className='About_vission_mission_card'>
                                <div className='inner_card_holder'>
                                    <div className='img_holder'>
                                        <img className="logo_img"
                                            src={
                                                process.env.PUBLIC_URL +
                                                "/assets/images/about_us/about_vission_mission/experties.png"
                                            }
                                            alt="ayansh logo" />
                                    </div>

                                    <div className='text_holder'>
                                        <h4>Our Expertise</h4>

                                        <div className='list_holder'>
                                            <ul>
                                                <li>Affirming our reputation as a true
                                                    merchant trader. </li>

                                                <li>We have built dedicated team
                                                    of experts</li>

                                                <li>Commodities Trading and Procurement
                                                    & Supply divisions to source and deliver.</li>

                                                <li>Commodities and capital
                                                    equipment to any destination.</li>

                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default About_vission_mission